import { useCallback } from "react";
import { Grid, Divider, Typography } from "@material-ui/core";
import { Box, Button, List, ListItem } from "~/components/UI";
import Highlighter from "react-highlight-words";
import history from "~/packages/history";
import ROUTES from "~/constants/routes";
import { useTranslation } from "react-i18next";

interface AcquirersEndpointsResultProps {
  data?: Api.SearchResult<AcquirersApi.AcquirerEndpointsSearchResult>;
  searchQuery: string;
}

const AcquirersEndpoint = ({
  acquirerEndpoint,
  searchQuery,
}: {
  searchQuery: string;
  acquirerEndpoint: AcquirersApi.AcquirerEndpointsSearchResult;
}) => {
  const openGroup = useCallback(() => {
    history.push(
      `${ROUTES.ACQUIRERS}?acquirersEndpointId=${acquirerEndpoint.id}`
    );
  }, [acquirerEndpoint.id]);

  return (
    <ListItem button onClick={openGroup}>
      <Typography variant="body2" color="textSecondary">
        <Highlighter
          searchWords={[searchQuery]}
          textToHighlight={acquirerEndpoint.url}
        />{" "}
        [
        <Typography variant="body2" component="span" color="primary">
          ID
        </Typography>
        :{" "}
        <Highlighter
          searchWords={[searchQuery]}
          textToHighlight={acquirerEndpoint.id}
        />
        ]
      </Typography>
      <Divider />
    </ListItem>
  );
};

/**
 * @memberof GlobalSearch
 * @component
 * @desc Render of search results for the AcquirerEndpoints catalog.
 * @property {string} searchQuery - the text we are looking for
 * @property {Api.SearchResult<AcquirersApi.SearchResult>} data - api response
 */

const AcquirerEndpoints = ({
  data,
  searchQuery,
}: AcquirersEndpointsResultProps) => {
  const { t } = useTranslation();

  const onShowAll = useCallback(() => {
    setTimeout(() => {
      history.push(`${ROUTES.ACQUIRERS}?search=${searchQuery}`);
    }, 0);
  }, [searchQuery]);

  if (data && data.count) {
    return (
      <Box mb={4}>
        <Box py={4}>
          <Grid container alignItems="center">
            <Grid item sm>
              <Typography variant="subtitle1">
                {t("title.catalogAcquirerEndpoints")} ({data.count})
              </Typography>
            </Grid>
            <Grid item>
              <Button variant="outlined" onClick={onShowAll}>
                {t("button.showAll")}
              </Button>
            </Grid>
          </Grid>
        </Box>
        <List>
          {data.data.map((e, index) => (
            <AcquirersEndpoint
              key={e.id}
              searchQuery={searchQuery}
              acquirerEndpoint={e}
            />
          ))}
        </List>
      </Box>
    );
  } else {
    return null;
  }
};

export default AcquirerEndpoints;
